module.exports = __webpack_public_path__ + "static/media/441494903_2343583472502393_364197299295303874_n-min.7ce33754.jpg";